/** CoStar.Api.Autocomplete.HealthCheck.CoreStatus */
export var CoreStatus;
(function (CoreStatus) {
    CoreStatus[CoreStatus["Unknown"] = 0] = "Unknown";
    CoreStatus[CoreStatus["Ok"] = 1] = "Ok";
    CoreStatus[CoreStatus["Down"] = 2] = "Down";
    CoreStatus[CoreStatus["Slow"] = 3] = "Slow";
    CoreStatus[CoreStatus["Empty"] = 4] = "Empty";
    CoreStatus[CoreStatus["SlaveConfiguredAsMaster"] = 5] = "SlaveConfiguredAsMaster";
    CoreStatus[CoreStatus["SlaveNotConfiguredAsSlave"] = 6] = "SlaveNotConfiguredAsSlave";
    CoreStatus[CoreStatus["SlavePollingDisabled"] = 7] = "SlavePollingDisabled";
    CoreStatus[CoreStatus["ReplicationStale"] = 8] = "ReplicationStale";
    CoreStatus[CoreStatus["MasterConfiguredAsSlave"] = 9] = "MasterConfiguredAsSlave";
    CoreStatus[CoreStatus["MasterNotConfiguredAsMaster"] = 10] = "MasterNotConfiguredAsMaster";
    CoreStatus[CoreStatus["MasterReplicationDisabled"] = 11] = "MasterReplicationDisabled";
})(CoreStatus || (CoreStatus = {}));
